import { useMemo } from 'react';
import { useAtom } from 'ximple';
import { paymentPlanAtom } from 'src/state/payment-plan/paymentPlanAtom';
import { useMemberContext } from 'src/widgets/timeslots/timeslots/MemberContext';
import {
    getAllPaymentPlans,
    getPaymentPlanInfo,
    PaymentPlanInfo,
} from '@repo/widget-utils/traversals/paymentPlan';

export type IsPaymentRequiredResult = {
    isPaymentRequired: boolean;
    paymentPlanInfo: PaymentPlanInfo;
};

export function useIsPaymentRequired(): IsPaymentRequiredResult {
    const { valueCardsForUser } = useMemberContext();
    const [{ paymentPlanResponse }] = useAtom(paymentPlanAtom);

    return useMemo(() => {
        const paymentPlanInfo = getPaymentPlanInfo(
            getAllPaymentPlans(paymentPlanResponse),
            valueCardsForUser,
        );
        return {
            paymentPlanInfo,
            isPaymentRequired: paymentPlanInfo.currencyCost > 0,
        };
    }, [paymentPlanResponse, valueCardsForUser]);
}
